import { Info } from '@phosphor-icons/react';
import { ReportSkeleton, type ReportSkeletonVariant } from './report-skeleton';
import { getAnalyticsErrorMessage } from '../utils/analytics-errors';

export function DeliveryDataNotice() {
  return (
    <div className="flex items-start gap-2.5 rounded-lg border border-[#F0C98A] bg-[#FFFCF5] px-4 py-3">
      <Info className="mt-0.5 size-4 shrink-0 text-[#b07d10]" aria-hidden />
      <p className="text-xs text-neutral-700">
        Delivery data has not been received yet. Sent counts are real. Delivered, bounce and
        complaint figures stay hidden until mailbox-provider events arrive — a zero here would be a
        missing result, not a rate.
      </p>
    </div>
  );
}

export function ReportRequestState({
  invalidRange,
  isLoading,
  error,
  skeleton = 'overview',
}: {
  invalidRange?: boolean;
  isLoading?: boolean;
  error?: unknown;
  skeleton?: ReportSkeletonVariant;
}) {
  if (invalidRange) {
    return (
      <p className="rounded-lg border border-[#E9A9A9] bg-[#FDF5F5] px-4 py-3 text-sm text-neutral-800">
        ‘from’ must not be after ‘to’.
      </p>
    );
  }
  if (isLoading) {
    return <ReportSkeleton variant={skeleton} />;
  }
  if (error) {
    return (
      <p className="rounded-lg border border-[#E9A9A9] bg-[#FDF5F5] px-4 py-3 text-sm text-neutral-800">
        {getAnalyticsErrorMessage(error)}
      </p>
    );
  }
  return null;
}
